import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignDesignInputValidation } from '../Product.hooks';
import {
  ProductValidation,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignValidationDialog from './AssignValidationDialog';

export type DesignInputAssignValidationDialogProps = BaseProductAssignDialogProps<'designInputId'>;

const DesignInputAssignValidationDialog: React.FC<DesignInputAssignValidationDialogProps> = (
  props: DesignInputAssignValidationDialogProps
) => {
  const {
    open,
    productId,
    designInputId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductDesignInput,
    isAssigning,
    error: assignError,
    assignValidations
  } = useAssignDesignInputValidation(productId, designInputId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductDesignInput) {
      onAssigned?.(updatedProductDesignInput);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductDesignInput]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignValidationDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'validation'
      )} to assign to the ${getProductEntityName('designInput')}.`}
      onSubmit={(validations: ProductValidation[]) => {
        assignValidations({
          validationIds: validations.map(
            (validation: ProductValidation) => validation.id
          )
        });
      }}
    />
  );
};

export default DesignInputAssignValidationDialog;
